import { FC, Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ICourse } from '../../../models/courses.model';
import Button from '../../Button';
import { Select } from 'antd';
import SelectDateModal from '../../modals/SelectDateModal';
import moment from 'moment';
import Radio from '../../Radio';
import CustomTimePicker from '../../CustomTimePicker';
import useNotification from '../../../hooks/useNotification';
import SelectSemesterCourseSubject from '../../SelectSemesterCourseSubject';
import useAxios from '../../../hooks/useAxios';
import { IGetSemesterCourseSubjects, IGetSubjects } from '../../../models/subject.model';
import { getSemesterCourseSubjects, getSubjects } from '../../../api/subject.api';
import Loader from '../../Loader';
import ErrorResponse from '../../ErrorResponse';
import ClassSubjectModal from './modals/ClassSubjectModal';
import { IClassSubjectReq } from '../../../models/campusClasses.model';
import { SEMESTER_TYPE } from '../../../constans';

interface IProps {
  courseInfo: ICourse;
  scheduleInput: any;
  onSetScheduleInput: (index: number, key: string, value: string) => void;
  dayList: any;
  onSetStartTime: (id: any, value: string) => void;
  onSetScheduleClassesInput: (
    id: string,
    key: string,
    value: any,
  ) => void;
  classroomList: any;
  campus: string | undefined;
  setTeacherInputRef: any;
  onOpenSelectTeacher: () => void;
  regYn: string;
  isUpdate: boolean;
  onSubjectUpdate?: (req: IClassSubjectReq[]) => void;
  semester: any;
  semesterType: string;
}

const ClassTimetable2: FC<IProps> = ({
  courseInfo,
  scheduleInput,
  onSetScheduleInput,
  dayList,
  onSetStartTime,
  onSetScheduleClassesInput,
  classroomList,
  campus,
  setTeacherInputRef,
  onOpenSelectTeacher,
  regYn,
  isUpdate,
  onSubjectUpdate,
  semester,
  semesterType,
}) => {
  const { t } = useTranslation();
  const { infoNotification } = useNotification();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetSemesterCourseSubjects>();

  const {
    data: subjectRes,
    execute: subjectExecute,
  } = useAxios<IGetSubjects>();

  useEffect(() => {
    if (courseInfo?.semesterCourseCode) {
      if (semesterType == SEMESTER_TYPE.REGULAR) {
        execute(
          getSemesterCourseSubjects({
            semesterCourseCode: courseInfo.semesterCourseCode,
          }),
        );
      } else {
        subjectExecute(getSubjects());
      }
    }
  }, [courseInfo]);

  const [classItem, setClassItem] = useState<any>();
  const [selectDateVisible, setSelectDateVisible] = useState(false);
  const [classSubjectVisible, setClassSubjectVisible] = useState(false);

  const subjects = semesterType === SEMESTER_TYPE.REGULAR ? res?.data : subjectRes?.data;

  const onOpenDateModal = async (classItem: any) => {
    if (!classItem.startTime) {
      return infoNotification(t('class.class.message17'));
    }

    setClassItem(classItem);
    setSelectDateVisible(true);
  };

  const renderClassTimeTable = () => {
    if (!courseInfo) {
      return (
        <tr>
          <td className="px-1 v-line text-center" colSpan={6}>
            {t('class.class.text10')}
          </td>
        </tr>
      );
    }

    const _response = scheduleInput?.reduce((acc: any, item: any) => {
      if (acc[item.day]) {
        acc[item.day] = [...acc[item.day], ...item.classes];
        return acc;
      }

      acc[item.day] = [...item.classes];
      return acc;
    }, {})

    return Object.keys(_response).map((key, index) => {
      const classInfo = _response[key];

      return (
        <Fragment key={index}>
          <tr>
            <td className="text-center" rowSpan={classInfo.length + 1}>
              Day {index + 1}
            </td>
          </tr>
          {
            classInfo.map((c: any, subIndex: number) => {
                return (
                  <tr key={subIndex}>
                    <td className="text-center">{subIndex + 1}</td>
                    <td className="text-center">
                      <SelectSemesterCourseSubject
                        subjectCode={c.subjectCode}
                        setSubjectCode={(value) => {
                          onSetScheduleClassesInput(c.id, 'subjectCode', value);
                        }}
                        subjects={subjects}
                        disabled={isUpdate}
                      />
                    </td>
                    <td className="text-center">
                      <div className="time-picker__area w-120p">
                        <CustomTimePicker
                          value={c?.startTime}
                          onSelect={(value) => {
                            if (value) {
                              onSetStartTime(c?.id, moment(value).format('HH:mm'));
                            } else {
                              onSetStartTime(c?.id, '');
                            }
                          }}
                          minuteStep={10}
                        />
                      </div>
                    </td>
                    <td className="text-center">
                      <Select
                        className="w-100"
                        placeholder={t('common.button.select')}
                        value={String(c?.classroom)}
                        onChange={(value) =>
                          onSetScheduleClassesInput(c.id, 'classroom', value)
                        }
                        disabled={!campus}
                      >
                        {classroomList?.map((item: any) => {
                          return (
                            <Select.Option key={item.value} value={item.value}>
                              {item.label}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </td>
                    <td>
                      <div className="comm-btn__area">
                        <Button
                          className="btn-basic small mint"
                          onClick={() => {
                            setTeacherInputRef({ id: c.id });
                            onOpenSelectTeacher();
                          }}
                          text={t('common.button.select')}
                        />
                        <span className="v-line">{c?.teacher?.memberName}</span>
                      </div>
                    </td>
                    {
                      regYn === 'Y' ? (
                        <td>
                          <div className="comm-btn__area">
                            <Button
                              className="btn-basic small mint"
                              onClick={() =>
                                onOpenDateModal(c)
                              }
                              text={t('common.button.save')}
                            />
                          </div>
                        </td>
                      ) : null
                    }
                  </tr>
                )
            })
          }
        </Fragment>
      )
    });
  };

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className="comm-bx__between">
        <h3 className='sub-title'>{t('class.class.title5')}</h3>
      </div>
      <div className='comm-table__area rowType edit'>
        <table>
          <colgroup>
            <col width="200px" />
            <col width="50px" />
            <col width="150px" />
            <col width="90px" />
            <col width="15%" />
            <col width="*" />
            {regYn === 'Y' && <col width="10%" />}
          </colgroup>
          <tbody>
            <tr>
              <th className="text-center">{t('class.class.9')}</th>
              <th className="text-center">{t('class.class.column22')}</th>
              <th className="text-center">
                <div className="comm-btn__area justify-content-center">
                  <span className={isUpdate?'v-line':''}>{t('class.class.10')}</span>
                  {isUpdate && (
                    <Button
                      className="btn-basic small mint ml-1"
                      text={t('class.class.11')}
                      onClick={() => {
                        setClassSubjectVisible(true);
                      }}
                    />
                  )}
                </div>
              </th>
              <th className="text-center">{t('class.class.column23')}</th>
              <th className="text-center">{t('class.class.column24')}</th>
              <th className="text-center">{t('class.class.column25')}</th>
              {regYn === 'Y' && (
                <th className="text-center">{t('common.button.save')}</th>
              )}
            </tr>
            {renderClassTimeTable()}
          </tbody>
        </table>
      </div>

      {selectDateVisible && (
        <SelectDateModal
          visible={selectDateVisible}
          setVisible={setSelectDateVisible}
          classItem={classItem}
        />
      )}
      {classSubjectVisible && onSubjectUpdate && (
        <ClassSubjectModal
          courseInfo={courseInfo}
          scheduleInput={scheduleInput}
          subjects={subjects}
          onClose={() => setClassSubjectVisible(false)}
          onSetScheduleClassesInput={onSetScheduleClassesInput}
          onOk={onSubjectUpdate}
          semester={semester}
        />
      )}
    </>
  );
};

export default ClassTimetable2;
